<template>
  <label :class="wrapperClasses">
    <input
      ref="input"
      :checked="currentChecked"
      :class="inputClasses"
      :disabled="disabled"
      :value="inputValue"
      type="checkbox"
      @change="$_onChange"
      @focus="focus = true"
      @blur="focus = false"
    >
    <span :class="innerClasses"><slot>{{ label }}</slot></span>
  </label>
</template>

<script>
import { PREFIX_CLASS } from '@/utils/constants'
import Emitter from '../../mixins/emitter'

const PREFIX_CLS = `${PREFIX_CLASS}form-checkbox`

export default {
  name: 'TCheckbox',
  inject: {
    groupVM: { default: null }
  },
  mixins: [Emitter],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Boolean, String, Number, Array, Object, Function, Symbol, Date],
      default: null
    },
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: [String, Number, Boolean],
      default: ''
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '',
      validator(val) {
        /* istanbul ignore next */
        return ['lg', 'sm', ''].includes(val)
      }
    }
  },
  data() {
    return {
      currentChecked: false,
      inputValue: this.value ? this.value : this.label
    }
  },
  computed: {
    wrapperClasses() {
      return [
        PREFIX_CLS,
        {
          [`${PREFIX_CLS}--checked`]: this.currentChecked,
          [`${PREFIX_CLS}--disabled`]: this.disabled,
          [`${PREFIX_CLS}--indeterminate`]: this.indeterminate,
          [`${PREFIX_CLS}--${this.size}`]: !!this.size
        }
      ]
    },
    innerClasses() {
      return `${PREFIX_CLS}__inner`
    },
    inputClasses() {
      return `${PREFIX_CLS}__input`
    }
  },
  watch: {
    checked(newVal) {
      this.currentChecked = newVal
    }
  },
  mounted() {
    if (this.groupVM) {
      this.unwatch = this.$watch('groupVM.value', (newVal) => {
        this.currentChecked = newVal.includes(this.inputValue)
      })
      this.currentChecked = this.groupVM.value.includes(this.inputValue)
    } else {
      this.currentChecked = this.checked
    }
  },
  destroyed() {
    this.unwatch && this.unwatch()
  },
  methods: {
    focus() {
      this.$refs.input.$el.focus()
    },
    $_onChange(evt) {
      if (this.disabled) {
        return false
      }
      if (!evt.target) {
        return false
      }
      const checked = evt.target.checked
      this.currentChecked = checked
      this.$_emitEvents(checked)
    },
    $_emitEvents(checked) {
      if (this.groupVM) {
        this.groupVM.$_updateValue(this.inputValue, checked)
      } else {
        this.$emit('update:checked', checked)
        this.$emit('change', checked)
        // NOTE: 用于form验证
        this.dispatch('TFormItem', 'g-on-form-change', checked)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/checkbox/checkbox.vue